<template>
  <svg class="rowLeft" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 41" width="23" height="41">
    <g id="Clients Reviews">
      <path id="Forma 1 copy 4" class="shp0" d="M0.95 22.66L18.21 40.02C19.31 41.12 21.09 41.12 22.19 40.02C23.28 38.91 23.28 37.12 22.19 36.02L6.91 20.66L22.19 5.3C23.28 4.2 23.28 2.41 22.19 1.3C21.09 0.2 19.31 0.2 18.21 1.3L0.95 18.66C0.4 19.21 0.12 19.94 0.12 20.66C0.12 21.38 0.4 22.11 0.95 22.66Z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'rowLeft',
};
</script>

<style scoped>
.rowLeft{
  fill: currentColor;
}
</style>
